import { Box, styled, Typography } from 'opensolar-ui'
import { useState } from 'react'

const Chip = styled(Box, { name: 'Chip' })(() => ({
  border: '1px solid rgb(0, 0, 0, 0.3)',
  borderRadius: '4px',
  display: 'flex',
  justifyContent: 'center',
}))

const ChipImage = styled('div', { name: 'ChipImage' })(() => ({
  height: '22px',
  width: '35px',
  padding: '2px 4px',
  boxSizing: 'border-box',
}))

const Logo = styled('img', { name: 'SupplierLogo' })({
  objectFit: 'contain',
  width: '100%',
  height: '100%',
})

const SupplierNameWrapper = styled('div', { name: 'SupplierNameWrapper' })({
  overflow: 'hidden',
  minWidth: 0,
  maxWidth: '100%',
  textAlign: 'right',
})

const SupplierName = styled(Typography, { name: 'SupplierName' })({
  fontSize: '12px !important',
  display: 'block',
})

interface SupplierLogoWithFallbackProps {
  logoUrl?: string
  name: string
}

const SupplierLogoWithFallback = ({ logoUrl, name }: SupplierLogoWithFallbackProps) => {
  const [failed, setFailed] = useState(false)

  if (!logoUrl || failed) {
    return (
      <SupplierNameWrapper>
        <SupplierName textVariant="helper1" title={name} noWrap>
          {name}
        </SupplierName>
      </SupplierNameWrapper>
    )
  }

  return (
    <Chip>
      <ChipImage>
        <Logo src={logoUrl} alt={name} onError={() => setFailed(true)} />
      </ChipImage>
    </Chip>
  )
}

export default SupplierLogoWithFallback
